import React from 'react'
import "./Consult.css"

const Consult = () => {
    return (
        <div className='consult-main'>
            <div className="consult-container">
                <div className="consult-left">
                    <span>Ready to open the ledger on your own wealth?</span>
                    <span1>Free first consultation. No obligation, no pressure.</span1>
                </div>
                <div className="consult-right">
                  <a href="#cont">Book A CONSULTATION</a>
                </div>

            </div>
        </div>
    )
}

export default Consult